import _ from 'lodash';
import { createSelector } from 'reselect';

const usersKey="homeState";

export const getHomeState = (state) => _.get(state, usersKey);
export const getCustomer = createSelector(getHomeState, (state) => _.get(state, 'customerName'));


